import apiClient from './client';

/**
 * Messages API endpoints
 * Backend routes: routes/messages.routes.js
 */
export const messagesApi = {
  // Core message endpoints
  getAll: (params) => apiClient.get('/messages', { params }),
  getById: (id) => apiClient.get(`/messages/${id}`),
  send: (data) => apiClient.post('/messages/send', data),
  getDetails: (id) => apiClient.get(`/messages/${id}/details`),
  markAsRead: (id) => apiClient.post(`/messages/${id}/read`),
  delete: (id) => apiClient.delete(`/messages/${id}`),

  // Filtered message views
  getServiceMessages: (params) => apiClient.get('/messages/service', { params }),
  getBusinessMessages: (params) => apiClient.get('/messages/business', { params }),

  // Reports
  getReport: (params) => apiClient.get('/messages/report', { params }),

  // Conversation
  getConversation: (customerId, params) =>
    apiClient.get(`/messages/conversation/${customerId}`, { params }),

  // Media
  sendMedia: (formData) =>
    apiClient.post('/messages/send-media', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  // Quick replies
  getQuickReplies: () => apiClient.get('/messages/quick-replies'),
  saveQuickReply: (data) => apiClient.post('/messages/quick-replies', data),
  deleteQuickReply: (id) => apiClient.delete(`/messages/quick-replies/${id}`),
};

export default messagesApi;
